export const history = {
    en: {
        aside: {
            historical: 'History',
            history: {
                help: 'When activating this option, the route of each device is displayed with informational events, without being able to interact with the devices.',
                menuSearch: 'Search Vehicle',
                menuTitle: 'QUERY',
                menuDetails: 'DETAILS',
                menuConsult: 'START',
                menuSpeed: 'MPH',
                menuPrint: 'PRINT',
                menuPoint: 'SEARCH IN POINT',
                menuTotalMileage: 'MI',
                navDate: 'DATE',
                navHour: 'TIME',
                navSpeed: 'SPEED',
                navOdometer: 'TRIP',
                title: 'Map View',
                typeHistory: 'Show only the route',
                styles: ['GS TrackMe', 'Google view', 'Terrain', 'Satellite', 'Hybrid', '45º view'],
                selectInMap: 'SELECT IN MAP',
                selectDates: 'Select days'
            },
            logout: 'Logout'
        },
        mapview: {
            toastPoi: "You have not created any P.O.I",
            titleToastPoi: "P.O.I",
            toastGeo: "You have not created any Geofence",
            geoSuccess: "Data loaded successfully",
            titleToastGeo: "GEOFENCES",
            timeError: "TIME",
            titleToastTime: "Start time greater than end time",
            titleToastDevice: "Dispositives",
            checkDevices: "Select _DEVICES_ or fewer devices",
            checkDevice: "Select 10 or fewer devices",
            titleToastDate: "DATE",
            checkDate: "Select a valid date",
            titleToastData: "INFO",
            titleToastError: "ERROR",
            dataError: "Query failure",
            titleToastDataCero: "No data for the query"
        },
        alarms: {
            title: 'SELECT A DEVICE TO SEE YOUR ALERTS',
            noalarms: "NO EVENTS TRIGGERED",
            icons: [
                { code: '001', label: 'SOS button', vshow: true, active: false, quantity: 0, value: false },
                { code: '002', label: 'Engine ignition', vshow: true, active: false, quantity: 0, value: false },
                { code: '003', label: 'Engine shutdown', vshow: true, active: false, quantity: 0, value: false },
                { code: '004', label: 'Open door', vshow: true, active: false, quantity: 0, value: false },
                { code: '006', label: 'GPS Unplugged', vshow: true, active: false, quantity: 0, value: false },
                { code: '007', label: 'Low battery', vshow: true, active: false, quantity: 0, value: false },
                { code: '015', label: 'Gasoline increase', vshow: true, active: false, quantity: 0, value: false },
                { code: '016', label: 'Gasoline decrease', vshow: true, active: false, quantity: 0, value: false },
                { code: '019', label: 'Sweeper', vshow: true, active: false, quantity: 0, value: false },
                { code: '021', label: 'PTO', vshow: true, active: false, quantity: 0, value: false },
                { code: '025', label: 'Idle', vshow: true, active: false, quantity: 0, value: false },
                { code: '026', label: 'Revolutions per minute', vshow: true, active: false, quantity: 0, value: false },
                { code: '027', label: 'Acceleration', vshow: true, active: false, quantity: 0, value: false },
                { code: '028', label: 'Deceleration', vshow: true, active: false, quantity: 0, value: false },
                { code: '030', label: 'Stop', vshow: true, active: false, quantity: 0, value: false },
                { code: '032', label: 'Speeding', vshow: true, active: false, quantity: 0, value: false },
                { code: '033', label: 'Posted Speed', vshow: true, active: false, quantity: 0, value: false },
                { code: '035', label: 'Entry to geofence', vshow: true, active: false, quantity: 0, value: false },
                { code: '036', label: 'Geofence exit', vshow: true, active: false, quantity: 0, value: false },
                { code: '037', label: 'Minimum time in point unfulfilled', vshow: true, active: false, quantity: 0, value: false },
                { code: '038', label: 'Maximum time in point exceeded', vshow: true, active: false, quantity: 0, value: false },
                { code: '060', label: 'Start of route', vshow: true, active: false, quantity: 0, value: false },
                { code: '061', label: 'End of route', vshow: true, active: false, quantity: 0, value: false },
                { code: '062', label: 'Route deviation', vshow: true, active: false, quantity: 0, value: false },
                { code: '071', label: 'Route deviation', vshow: true, active: false, quantity: 0, value: false },
                // { code: '994', label: 'Sleep Mode', vshow:true, active:true, quantity:0,value:false},
                // { code: '996', label: 'Memory Lost', vshow:true, active:true, quantity:0,value:false},
                { code: '997', label: 'Check engine light', vshow: true, active: false, quantity: 0, value: false },
                { code: '998', label: 'Device Restart', vshow: true, active: false, quantity: 0, value: false },
                { code: '999', label: 'GPS signal lost', vshow: true, active: false, quantity: 0, value: false },
				{ code: '050', label: 'WiFi connection', vshow: true, active: false, quantity: 0, value: false },
				{ code: '051', label: 'Data connection', vshow: true, active: false, quantity: 0, value: false },
				// { code: '053', label: 'App manipulation', vshow: true, active: false, quantity: 0, value: false },
				{ code: '054', label: 'Check in', vshow: true, active: false, quantity: 0, value: false },
				{ code: '055', label: 'Check out', vshow: true, active: false, quantity: 0, value: false },
				// { code: '056', label: 'Rest start', vshow: true, active: false, quantity: 0, value: false },
				// { code: '057', label: 'End of rest', vshow: true, active: false, quantity: 0, value: false },
            ],
            info: {
                start: 'Start',
                stop: 'Stop',
                idle: 'Idle',
                duration: 'Duration',
                speed: 'Speed'
            }
        },
        actions: {
            title: '',
            icons: [
                { code: 'center', label: 'Center vehicle', selected: true },
                { code: 'hide', label: 'Show/Hide vehicle', selected: true },
                { code: 'route', label: 'Show/Hide route', selected: false },
                { code: 'poi', label: 'Show/Hide Pois' },
                { code: 'geofence', label: 'Show/Hide Geofences' },
                { code: 'street-view', label: 'Street View', selected: false },
                { code: 'history', label: 'Show history', selected: false },
            ]
        },
        infowindow: {
            titles: {
                general: 'GENERAL',
                details: 'DETAILS',
                admin: 'ADMIN',
                technical: 'Technical details',
                clientDet: 'Client details'
            },
            subtitles: {
                status: ['WITHOUT SIGNAL', 'STOPPED', 'IDLING', 'IN MOVEMENT', 'WITHOUT GPS SIGNAL', 'IN SLEEP MODE', 'WITH ENGINE STOP COMMAND'],
                diff: ['DAYS', 'HOURS', 'MINUTES', 'SECONDS'],
                brand: 'Brand',
                make: 'Make',
                model: 'Model',
                year: 'Year',
                // speedLimit: 'Posted Speed',
                speedLimit: 'Speed Treshold',
                street: 'Street',
                gas: 'Gasoline',
                // postSpeed: 'Speed Limit',
                postSpeed: 'Posted Speed',
                plates: 'Plates',
                mileage: 'Speed',
                quickActions: 'Quick Actions',
                businessName: 'BUSINESS NAME',
                imei: 'IMEI',
                phone: 'PHONE',
                port: 'DEVICE PORT',
                device: 'DEVICE',
                alias: 'ALIAS',
                contact: 'CONTACT',
                user: 'USER',
                movil: 'MOBILE',
                city: 'CITY'
            }
        },
        orientation: {
            n: 'TO THE NORTH AT',
            ne: 'TO THE NORTHEAST AT',
            nw: 'TO THE NORTHWEST AT',
            e: 'TO THE EAST AT',
            w: 'TO THE WEST AT',
            se: 'TO THE SOUTHEAST AT',
            sw: 'TO THE SOUTHWEST AT',
            s: 'TO THE SOUTH AT',
            ng: 'A'
        },
        notifications: {
            geofences: ['Geofences loaded successfully.', 'Without geofences.', 'An error has occurred.'],
            pois: ['POIS loaded successfully.', 'Without POIS.', 'An error has occurred.'],
            routes: ['Routes loaded successfully.', 'Without Routes.', 'An error has occurred.'],
            playButton: 'Select device to start travel.'
        },
        searchbypoint: {
            title: 'Search By Point',
            listtitle: 'Results',
            cancel: 'Cancel',
            search: 'Search'
        },
		speedconf: {
			title: 'Speed configuration',
			note: 'For MIN and MAX type the value and then press ENTER to assign it ',
			device: {
				label: 'Device',
				placeholder: 'Select a device to configure'
			},
			columns: ['Segment', 'Color', 'Min', 'Max'],
			buttons: {
				cancel: 'Cancel',
				save: 'Save'
			},
			notifications: {
				success: 'Speeds configuration was updated successfully',
				warning: '',
				error: 'Was an error occurred, please try again'
			}
		}
    },
    es: {
        aside: {
            historical: 'Historico',
            history: {
                help: 'Al activar esta opción, se visualizará el recorrido de cada dispositivo con eventos informativos, sin poder interactuar con los dispositivos.',
                menuSearch: 'Buscar Vehiculo',
                menuTitle: 'CONSULTA',
                menuDetails: 'DETALLES',
                menuConsult: 'CONSULTAR',
                menuSpeed: 'km/h',
                menuPrint: 'IMPRIMIR',
                menuPoint: 'BUSCAR EN PUNTO',
                menuTotalMileage: 'km',
                navDate: 'FECHA',
                navHour: 'HORA',
                navSpeed: 'VELOCIDAD',
                navOdometer: 'ODÓMETRO',
                title: 'Vista del mapa',
                typeHistory: 'Mostrar sólo el recorrido',
                styles: ['GS TrackMe', 'Vista Google', 'Terreno', 'Satélite', 'Híbrido', 'Vista 45º'],
                selectInMap: 'SELECCIONAR EN MAPA',
                selectDates: 'Seleccionar días'
            },
            logout: 'Cerrar sessión'
        },
        mapview: {
            toastPoi: "No tiene creado ningún P.O.I",
            titleToastPoi: "P.O.I",
            toastGeo: "No tiene creado ninguna Geocerca",
            geoSuccess: "Datos cargados con éxito",
            titleToastGeo: "GEOCERCAS",
            timeError: "HORA",
            titleToastTime: "Hora de inicio mayor que hora final",
            titleToastDevice: "Dispositivos",
            checkDevices: "Seleccione _DEVICES_ o menos dispositivos",
            checkDevice: "Seleccione 10 o menos dispositivos",
            titleToastDate: "FECHA",
            checkDate: "Seleccione una fecha válida",
            titleToastData: "INFO",
            titleToastError: "ERROR",
            dataError: "Fallo en la consulta",
            titleToastDataCero: "Sin datos para la consulta"
        },
        alarms: {
            title: 'SELECCIONE UN DISPOSITIVO PARA VER SUS ALERTAS',
            noalarms: 'SIN EVENTOS GENERADOS',
            icons: [
                { code: '001', label: 'Botón de pánico', vshow: true, active: false, quantity: 0, value: false },
                { code: '002', label: 'Encendido de motor', vshow: true, active: false, quantity: 0, value: false },
                { code: '003', label: 'Apagado de motor', vshow: true, active: false, quantity: 0, value: false },
                { code: '004', label: 'Puerta abierta', vshow: true, active: false, quantity: 0, value: false },
                { code: '006', label: 'Desconexión de GPS', vshotruew: true, active: false, quantity: 0, value: false },
                { code: '007', label: 'Batería baja', vshow: true, active: false, quantity: 0, value: false },
                { code: '015', label: 'Incremento de gasolina', vshow: true, active: false, quantity: 0, value: false },
                { code: '016', label: 'Decremento de gasolina', vshow: true, active: false, quantity: 0, value: false },
                { code: '019', label: 'Barredora', vshow: true, active: false, quantity: 0, value: false },
                { code: '021', label: 'Grúa', vshow: true, active: false, quantity: 0, value: false },
                { code: '025', label: 'Inactivo', vshow: true, active: false, quantity: 0, value: false },
                { code: '026', label: 'Revoluciones por minuto', vshow: true, active: false, quantity: 0, value: false },
                { code: '027', label: 'Aceleración', vshow: true, active: false, quantity: 0, value: false },
                { code: '028', label: 'Desaceleración', vshow: true, active: false, quantity: 0, value: false },
                { code: '030', label: 'Parada', vshow: true, active: false, quantity: 0, value: false },
                { code: '032', label: 'Exceso de velocidad', vshow: true, active: false, quantity: 0, value: false },
                { code: '033', label: 'Limite de Calle Excedido', vshow: true, active: false, quantity: 0, value: false },
                { code: '035', label: 'Entrada a geocerca', vshow: true, active: false, quantity: 0, value: false },
                { code: '036', label: 'Salida de geocerca', vshow: true, active: false, quantity: 0, value: false },
                { code: '037', label: 'Tiempo mínimo en punto incumplido', vshow: true, active: false, quantity: 0, value: false },
                { code: '038', label: 'Tiempo máximo en punto excedido', vshow: true, active: false, quantity: 0, value: false },
                { code: '060', label: 'Inicio de ruta', vshow: true, active: false, quantity: 0, value: false },
                { code: '061', label: 'Finalización de ruta', vshow: true, active: false, quantity: 0, value: false },
                { code: '062', label: 'Desvio de ruta', vshow: true, active: false, quantity: 0, value: false },
                { code: '071', label: 'Desvio de ruta', vshow: true, active: false, quantity: 0, value: false },
                // { code: '994', label: 'Modo Sueño', vshow:false,active:true,quantity:0,value:false},
                // { code: '996', label: 'Perdida de memoria', vshow:false,active:true,quantity:0,value:false},
                { code: '997', label: 'Error de Motor', vshow: true, active: false, quantity: 0, value: false },
                { code: '998', label: 'Reinicio de Dispositivo', vshow: false, active: false, quantity: 0, value: false },
                { code: '999', label: 'Perdida de Señal', vshow: true, active: false, quantity: 0, value: false },
				{ code: '050', label: 'Conexión Wifi', vshow: true, active: false, quantity: 0, value: false },
				{ code: '051', label: 'Conexión de datos', vshow: true, active: false, quantity: 0, value: false },
				// { code: '053', label: 'Manipulación de app', vshow: true, active: false, quantity: 0, value: false },
				{ code: '054', label: 'Entrada', vshow: true, active: false, quantity: 0, value: false },
				{ code: '055', label: 'Salida', vshow: true, active: false, quantity: 0, value: false },
				// { code: '056', label: 'Inicio de descanso', vshow: true, active: false, quantity: 0, value: false },
				// { code: '057', label: 'Termino de descanso', vshow: true, active: false, quantity: 0, value: false },
            ],
            info: {
                start: 'Inicio',
                stop: 'Inicio',
                idle: 'Inicio',
                duration: 'Duración',
                speed: 'Velocidad'
            }
        },
        actions: {
            title: '',
            icons: [
                { code: 'center', label: 'Centrar vehículo', selected: false },
                { code: 'hide', label: 'Mostar/Ocultar vehículo', selected: true },
                { code: 'route', label: 'Mostar/Ocultar rutas', selected: false },
                { code: 'poi', label: 'Mostar/Ocultar Puntos de interes' },
                { code: 'geofence', label: 'Mostar/Ocultar Geocercas' },
                { code: 'street-view', label: 'Actualizar Street View', selected: false },
                { code: 'history', label: 'Mostrar histórico', selected: false },
            ]
        },
        infowindow: {
            titles: {
                general: 'GENERAL',
                details: 'DETALLES',
                admin: 'ADMIN',
                technical: 'Detalles Técnicos',
                clientDet: 'Detalles del Cliente'
            },
            subtitles: {
                status: ['SIN SEÑAL', 'DETENIDO', 'ESTACIONADO', 'EN MOVIMIENTO', 'SIN SEÑAL GPS', 'EN AHORRO DE ENERGÍA', 'CON COMANDO DE PARO DE MOTOR'],
                diff: ['DÍAS', 'HORAS', 'MINUTOS', 'SEGUNDOS'],
                brand: 'Dispositivo',
                make: 'Marca',
                model: 'Modelo',
                year: 'Año',
                speedLimit: 'Límite de Vel.',
                street: 'Calle',
                gas: 'Gasolina',
                postSpeed: 'Límite en Calle',
                plates: 'Placas',
                mileage: 'Kilometraje',
                quickActions: 'Acciones Rápidas',
                businessName: 'NOMBRE EMPRESARIAL',
                imei: 'IMEI',
                phone: 'TELÉFONO',
                port: 'PUERTO',
                device: 'DISPOSITIVO',
                alias: 'ALIAS',
                contact: 'CONTACTO',
                user: 'USUARIO',
                movil: 'MÓVIL',
                city: 'CIUDAD'
            }
        },
        orientation: {
            n: 'HACIA EL NORTE A',
            ne: 'HACIA EL NORESTE A',
            nw: 'HACIA EL NOROESTE A',
            e: 'HACIA EL ESTE A',
            w: 'HACIA EL OESTE A',
            se: 'HACIA EL SURESTE A',
            sw: 'HACIA EL SUROESTE A',
            s: 'HACIA EL SUR',
            ng: 'A'
        },
        notifications: {
            geofences: ['Geocercas cargadas correctamente.', 'Sin geocercas.', 'Un error ha ocurrido.'],
            pois: ['POIS cargados correctamente.', 'Sin POIS.', 'Un error ha ocurrido.'],
            routes: ['Rutas cargadas correctamente.', 'Sin Rutas asignadas.', 'Un error ha ocurrido.'],
            playButton: 'Seleccione un dispositivo para iniciar el recorrido.'
        },
        searchbypoint: {
            title: 'Buscar por Geocerca',
            listtitle: 'Resultados',
            cancel: 'Cancelar',
            search: 'Buscar'
        },
		speedconf: {
			title: 'Configuración de velocidad',
			note: 'Para MIN y MAX ingrese el valor y luego presione ENTER para asignarlo',
			device: {
				label: 'Dispositivo',
				placeholder: 'Seleccione un dispositivo para configurar'
			},
			columns: ['Segmento', 'Color', 'Min', 'Max'],
			buttons: {
				cancel: 'Cancelar',
				save: 'Guardar'
			},
			notifications: {
				success: 'La configuración de velocidades se actualizó correctamente',
				warning: '',
				error: 'Se produjo un error, inténtelo de nuevo'
			}
		}
    }
};
